import Product from '../models/Product';
import ProductCard from './ProductCard';
import HorizontalScroll from './HorizontalScroll';

interface ProductBarProps {
    products: Product[] | undefined;
    extended: boolean;
}

function ProductBar(props: ProductBarProps) {

    return (
        <HorizontalScroll>
            {props.products?.map((productItem: Product, index: React.Key | null | undefined) => (
                <ProductCard key={index} product={productItem} extended={props.extended} />
            ))}
        </HorizontalScroll>
    );
}

export default ProductBar;